import { EMPLOYEE_STATUS } from './constants';

export const CREATE_EMPLOYEE = 'CREATE_EMPLOYEE';
export const GET_EMPLOYEES_LIST = 'GET_EMPLOYEES_LIST';
export const READ_EMPLOYEE_DASHBOARD = 'EMPLOYEE_FE_READ_EMPLOYEE_DASHBOARD';
export const READ_EMPLOYEE_PERMISSION = 'READ';
export const DELETE_EMPLOYEE = 'DELETE';
export const READ_EDUCATIONS_LIST = 'READ_EDUCATIONS_LIST';
export const READ_EMPLOYEE_COMPENSATION_PACKAGES = 'READ_EMPLOYEE_COMPENSATION_PACKAGES';
export const READ_EMPLOYEE_COMMUNICATIONS = 'READ_EMPLOYEE_COMMUNICATIONS';
export const READ_EMPLOYEE_CONTRACTS = 'PEOPLE_MANAGEMENT_CONTRACT_LIST_SEARCH_FOR_EMPLOYEE';
export const READ_EMPLOYEE_MAIN_PERSONAL_INFO = 'READ_EMPLOYEE_MAIN_PERSONAL_INFO';
export const READ_EMPLOYEE_MAIN_HR_INFORMATION = 'READ_EMPLOYEE_MAIN_HR_INFORMATION';
export const READ_EMPLOYEE_CONTACT_INFORMATION = 'READ_EMPLOYEE_CONTACT_INFORMATION';
export const READ_EMPLOYEE_QUALIFICATIONS = 'READ_EMPLOYEE_QUALIFICATIONS';
export const READ_EMPLOYEE_WORKING_STATUS = 'READ_EMPLOYEE_WORKING_STATUS';
export const READ_EMPLOYEE_IDENTITY_DOCUMENTS = 'READ_EMPLOYEE_IDENTITY_DOCUMENTS';
export const READ_EMPLOYEE_FAMILY_INFORMATION = 'READ_EMPLOYEE_FAMILY_INFORMATION';
export const READ_EMPLOYEE_ACCOUNTS_AZURE_ID = 'READ_EMPLOYEE_ACCOUNTS_AZURE_ID';
export const READ_EMPLOYEE_ACCOUNTS_1C_ID = 'READ_EMPLOYEE_ACCOUNTS_1C_ID';
export const READ_EMPLOYEE_TIMELINE = 'READ_EMPLOYEE_TIMELINE';
export const READ_EMPLOYEE_SPECIALIZATION_INFO = 'READ_EMPLOYEE_SPECIALIZATION_INFO';
export const UPDATE_EMPLOYEE_INITIALIZATION_STATE = 'UPDATE_INITIALIZATION_STATE';
export const UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO = 'UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO';
export const UPDATE_EMPLOYEE_MENTOR_INFO = 'PEOPLE_MANAGEMENT_EMPLOYEE_UPDATE_MENTORSHIP_INFO';
export const UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS = 'UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS';
export const UPDATE_EMPLOYEE_CONTACT_INFORMATION = 'UPDATE_EMPLOYEE_CONTACT_INFORMATION';
export const UPDATE_EMPLOYEE_FAMILY_INFORMATION = 'UPDATE_EMPLOYEE_FAMILY_INFORMATION';
export const UPDATE_EMPLOYEE_MILITARY_INFO = 'UPDATE_EMPLOYEE_MILITARY_INFO';
export const UPDATE_EMPLOYEE_MAIN_HR_INFORMATION = 'UPDATE_EMPLOYEE_MAIN_HR_INFORMATION';
export const READ_EMPLOYEE_PEOPLE_MANAGEMENT_RULES = 'READ_EMPLOYEE_PEOPLE_MANAGEMENT_RULES';
export const UPDATE_EMPLOYEE_PEOPLE_MANAGEMENT_RULES = 'UPDATE_EMPLOYEE_PEOPLE_MANAGEMENT_RULES';
export const UPDATE_EMPLOYEE_ACCOUNTS_AZURE_ID = 'UPDATE_EMPLOYEE_ACCOUNTS_AZURE_ID';
export const UPDATE_EMPLOYEE_ACCOUNTS_1C_ID = 'UPDATE_EMPLOYEE_ACCOUNTS_1C_ID';
const UPDATE_EMPLOYEE_WORKING_STATUS = 'UPDATE_EMPLOYEE_WORKING_STATUS';
export const UPDATE_EMPLOYEE_REQUISITES_INFORMATION = 'UPDATE_EMPLOYEE_REQUISITES_INFORMATION';
const UPDATE_EMPLOYEE_EXCHANGE_IDENTIFIER = 'UPDATE_EMPLOYEE_EXCHANGE_IDENTIFIER';
export const UPDATE_EMPLOYEE_SPECIALIZATION_INFO = 'UPDATE_EMPLOYEE_SPECIALIZATION_INFO';
const UPDATE_EMPLOYEE_TIMEZONE = 'UPDATE_EMPLOYEE_TIMEZONE';
export const READ_CAREER_DEVELOPMENT_NEXT_REVIEW_DATE = 'READ_CAREER_DEVELOPMENT_NEXT_REVIEW_DATE';
export const READ_EMPLOYEE_CAREER_DEVELOPMENT_INFORMATION = 'READ_EMPLOYEE_CAREER_DEVELOPMENT_INFORMATION';
const UPDATE_EMPLOYEE_CAREER_DEVELOPMENT_INFORMATION = 'UPDATE_EMPLOYEE_CAREER_DEVELOPMENT_INFORMATION';
export const UPDATE_CAREER_DEVELOPMENT_NEXT_REVIEW_DATE = 'UPDATE_CAREER_DEVELOPMENT_NEXT_REVIEW_DATE';
export const CREATE_EMPLOYEE_OFFER = 'CREATE_EMPLOYEE_OFFER';
export const READ_LIST_EMPLOYEE_OFFER = 'READ_LIST_EMPLOYEE_OFFER';
export const READ_LIST_EMPLOYEE_PERFORMANCE = 'READ_LIST_EMPLOYEE_PERFORMANCE';
export const READ_LEAD_RECRUITER = 'READ_LEAD_RECRUITER';

export const updateEmployeePermissions = {
  nameLocal: [UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO],
  nameEn: [UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO],
  workingEmail: [UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO],
  gender: [UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO],
  azureId: [UPDATE_EMPLOYEE_ACCOUNTS_AZURE_ID],
  officeId: [UPDATE_EMPLOYEE_MAIN_HR_INFORMATION],
  positionId: [UPDATE_EMPLOYEE_MAIN_HR_INFORMATION, UPDATE_EMPLOYEE_SPECIALIZATION_INFO],
  workingStatus: [UPDATE_EMPLOYEE_WORKING_STATUS],
  employeeType: [UPDATE_EMPLOYEE_MAIN_HR_INFORMATION],
  exchangeId: [UPDATE_EMPLOYEE_EXCHANGE_IDENTIFIER],
  timezone: [UPDATE_EMPLOYEE_TIMEZONE],
  specializationInfo: [UPDATE_EMPLOYEE_MAIN_HR_INFORMATION, UPDATE_EMPLOYEE_SPECIALIZATION_INFO],
  assignedPeopleManagerAliases: [UPDATE_EMPLOYEE_PEOPLE_MANAGEMENT_RULES],
  hasSpecificManagers: [UPDATE_EMPLOYEE_PEOPLE_MANAGEMENT_RULES],
  careerDevelopmentEvaluationMode: [UPDATE_EMPLOYEE_CAREER_DEVELOPMENT_INFORMATION],
  mentorshipInformation: [UPDATE_EMPLOYEE_MENTOR_INFO],
  extendedInformation: {
    photosIds: [UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO],
    dateOfBirth: [UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO],
    homeAddress: [UPDATE_EMPLOYEE_CONTACT_INFORMATION],
    registrationAddress: [UPDATE_EMPLOYEE_CONTACT_INFORMATION],
    personalEmail: [UPDATE_EMPLOYEE_CONTACT_INFORMATION],
    personalPhoneNumber: [UPDATE_EMPLOYEE_CONTACT_INFORMATION],
    otherPhoneNumber: [UPDATE_EMPLOYEE_CONTACT_INFORMATION],
    additionalContactInfo: [UPDATE_EMPLOYEE_CONTACT_INFORMATION],
    plannedMidTermLocation: [UPDATE_EMPLOYEE_CONTACT_INFORMATION],
    plannedPermLocation: [UPDATE_EMPLOYEE_CONTACT_INFORMATION],
    locationUpdateDate: [UPDATE_EMPLOYEE_CONTACT_INFORMATION],
    financialInformation: [UPDATE_EMPLOYEE_ACCOUNTS_1C_ID],
    identityDocuments: [UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS],
    hrInformation: [UPDATE_EMPLOYEE_MAIN_HR_INFORMATION],
    militaryRecord: [UPDATE_EMPLOYEE_MILITARY_INFO],
    familyMembers: [UPDATE_EMPLOYEE_FAMILY_INFORMATION],
    familyChildren: [UPDATE_EMPLOYEE_FAMILY_INFORMATION],
    maritalStatus: [UPDATE_EMPLOYEE_FAMILY_INFORMATION],
    requisitesInformation: [UPDATE_EMPLOYEE_REQUISITES_INFORMATION],
  },
};

export const EDIT_EMPLOYEE_PAGE_PERMISSIONS = [
  UPDATE_EMPLOYEE_ACCOUNTS_1C_ID,
  UPDATE_EMPLOYEE_ACCOUNTS_AZURE_ID,
  UPDATE_EMPLOYEE_CONTACT_INFORMATION,
  UPDATE_EMPLOYEE_MAIN_PERSONAL_INFO,
  UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS,
  UPDATE_EMPLOYEE_FAMILY_INFORMATION,
  UPDATE_EMPLOYEE_MILITARY_INFO,
  UPDATE_EMPLOYEE_MAIN_HR_INFORMATION,
  UPDATE_EMPLOYEE_WORKING_STATUS,
  UPDATE_EMPLOYEE_REQUISITES_INFORMATION,
];

export const DISMISSED_STATUS = EMPLOYEE_STATUS.DISMISSED;
export const ACTIVE_STATUS = EMPLOYEE_STATUS.ACTIVE;
export const IN_DISMISSAL_STATUS = EMPLOYEE_STATUS.IN_DISMISSAL;
export const RELOCATION_STATUS = EMPLOYEE_STATUS.RELOCATION;

export const EMPLOYEE_READ_NAME = 'EMPLOYEE_READ_NAME';

export const DOCUMENTS_ALIAS = {
  PASSPORT: 'PASSPORT',
  RESIDENCE_PERMIT: 'RESIDENCE_PERMIT',
  PESEL: 'PESEL',
  IDENTITY_CARD: 'IDENTITY_CARD',
  NIP: 'NIP',
  REGON: 'REGON',
};

export const DOCUMENTS = {
  PASSPORT: 'Passport',
  RESIDENCE_PERMIT: 'Residence Permit',
  PESEL: 'PESEL',
  IDENTITY_CARD: 'Identity card',
  NIP: 'NIP',
  REGON: 'REGON',
};

export const EMPLOYEE_CONTRACT_ASSIGMENT_ALIAS = {
  PART_TIME: 'PART_TIME',
  FULL_TIME: 'FULL_TIME',
};

export const EMPLOYEE_CONTRACT_ASSIGMENT_TYPES = {
  [EMPLOYEE_CONTRACT_ASSIGMENT_ALIAS.FULL_TIME]: 'Full-time',
  [EMPLOYEE_CONTRACT_ASSIGMENT_ALIAS.PART_TIME]: 'Part-time',
};
